import { render, staticRenderFns } from "./payment_canceled.vue?vue&type=template&id=cfe67e9e&"
import script from "./payment_canceled.vue?vue&type=script&lang=js&"
export * from "./payment_canceled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports